<template>
  <div class="neta-lists">
    <div class="list-menu">
      <a-menu v-model="currentList" mode="horizontal" :style="{background: 'transparent'}" align="center">
        <a-menu-item key="neta-bulletin-index">
          <a-icon type="read" />
          Faliújság
        </a-menu-item>

        <a-menu-item key="neta-bulletin-documents">
          <a-icon type="folder-open" />
          Dokumentumok
        </a-menu-item>
      </a-menu>
    </div>

    <div class="list-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NetaBulletinView',

  computed: {
    currentList: {
      get() {
        return [this.$route.name]
      },

      set(routeName) {
        this.$router.push({
          name: routeName[0]
        });
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.list-menu {
  margin-bottom: 10px;
}
</style>